/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceDesktop24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceDesktop24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 5.5C5 4.67157 5.67157 4 6.5 4H18.5C19.3284 4 20 4.67157 20 5.5V13.5C20 14.3284 19.3284 15 18.5 15H13V18H15.5V19H9.5V18H12V15H6.5C5.67157 15 5 14.3284 5 13.5V5.5ZM6.5 5C6.22386 5 6 5.22386 6 5.5V13.5C6 13.7761 6.22386 14 6.5 14H18.5C18.7761 14 19 13.7761 19 13.5V5.5C19 5.22386 18.7761 5 18.5 5H6.5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceDesktop24Icon.tags = [
  'computer',
  'monitor',
  'screen',
  'desktop',
  'display',
];

DeviceDesktop24Icon.category = '24x24';

DeviceDesktop24Icon.iconSize = 24;
